import {
  WidgetBuilderState,
  buildWidgetFromWidgetBuilderState,
} from 'sierra-client/features/insights/widget-builder/widget-builder-state'

export const isCompleteWidget = (x: WidgetBuilderState): boolean => {
  return buildWidgetFromWidgetBuilderState(x) !== undefined
}
